import Vue from 'vue';
import Component from 'vue-class-component';
import giftIcon from 'assets/icons/giftcard_2.svg';
import questionIcon from 'assets/icons/question_2.svg';
import smilingFace from 'assets/icons/SmilingFace.svg';
import changeGift from 'common/icons/ChangeGiftCopy.svg';
import giftcardIcon from 'assets/icons/giftcard.svg';
import useCreditIcon from 'assets/icons/efectivo.svg';
import knowWhat from 'assets/icons/knowWhat.svg';

@Component({
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    cta: {
      type: String,
      required: true,
    },
    goTo: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    mobileButtonStyle: {
      type: Boolean,
      default: true,
    },
  },
})
export default class HomeCardComponent extends Vue {
  icons = {
    question_2: questionIcon,
    giftcard_2: giftIcon,
    giftcard_1: giftcardIcon,
    useCredit: useCreditIcon,
    smilingFace,
    changeGift,
    knowWhat,
  };

  handleClick() {
    if (this.goTo) {
      this.$router.push({ name: this.goTo });
    } else {
      this.$emit('onClick');
    }
  }

  get cardIcon() {
    return this.icons[this.icon];
  }
}
